<template>
    <component
        v-bind:is="component"
        v-bind="$props"
        :name="getModalName()"
        height="auto"
        @before-open="setModalAsOpened"
        @closed="reset"
        :class="currentModalPosition !== -1 ? `vm--container--position-${currentModalPosition}` : ''"
    >
        <template v-if="opened">
            <slot v-bind:model="model"></slot>
        </template>
    </component>
</template>

<style>
    .vm--container--position-0 {
        z-index: 1010 !important;
    }
    .vm--container--position-1 {
        z-index: 1009 !important;
    }
    .vm--container--position-2 {
        z-index: 1008 !important;
    }
    .vm--container--position-3 {
        z-index: 1007 !important;
    }
    .vm--container--position-4 {
        z-index: 1006 !important;
    }
    .vm--overlay {
        backdrop-filter: blur(1px) !important;
        background: rgb(8 10 41 / 25%) !important;
    }
</style>

<script>
    export default {
        props: {
            component: {
                type: String,
                default: 'v-spa-right-panel-modal'
            },
            modelClass: {
                type: Function,
                default: null
            },
            modalName: {
                type: String,
                default: null
            },
            modalType: {
                type: String,
                default: 'default'
            },
            height: {
                required: false,
            },
            scrollable: {
                required: false,
                type: Boolean,
                default() {
                    return true;
                }
            },
            width: {
                required: false,
                default() {
                    return 600;
                }
            },
            showCloseIcon: {
                required: false,
                type: Boolean,
                default() {
                    return true;
                },
            },
            shiftX: {
                required: false,
                type: Number
            },
            shiftY: {
                required: false,
                type: Number
            },
            classes: {
                required: false,
                type: String
            },
            contentClasses: {
                required: false,
                type: String
            },
            transition: {
                required: false,
                type: String
            },
            slotContainerClasses: {
                required: false,
                type: String
            },
            rightPanelWidth: {
                required: false,
                type: String
            },
            rightPanelWidthXl: {
                required: false,
                type: String
            },
        },

        data() {
            return {
                model: null,
                opened: false
            }
        },

        computed: {
            currentModalPosition()
            {
                return this.$store.state.openedModals.indexOf(this.getModalName());
            }
        },

        methods: {
            getModalName()
            {
                if ( this.modalName ) {
                    return this.modalName;
                }

                let method = this.modalType == 'form' ? 'getFormModalName' : 'getModalName';
                return this.modelClass[method]();
            },
            
            getModalEvent()
            {
                if ( this.modalName ) {
                    return `${this.modalName}:open`;
                }

                let method = this.modalType == 'form' ? 'getFormModalEvent' : 'getModalEvent';
                return this.modelClass[method]();
            },

            async open(data = {})
            {
                this.$store.commit('moveOpenedModalToTop', this.getModalName());

                console.log('Modal open', this.getModalName(), data);
                if ( typeof data.model !== 'undefined' ) {
                    this.model = data.model;
                }
                
                this.$emit('opening', data);
                this.openModal();
                this.opened = true;
                this.$emit('opened', data);
            },

            openModal()
            {
                this.$modal.show(this.getModalName());
            },

            close()
            {
                this.$emit('closing');
                
                this.closeModal();
                this.opened = false;

                this.$emit('closed');
                this.$bus.$emit(`${this.getModalName()}:closed`);
            },

            closeModal()
            {
                this.$modal.hide(this.getModalName());
            },

            setModalAsOpened()
            {
                this.$store.commit('addOpenedModal', this.getModalName());
            },

            reset()
            {
                this.$emit('resetting');

                this.$store.commit('removeOpenedModal', this.getModalName());
                this.model = null;

                if ( this.$parent ) {
                    this.$parent.mixin_destroyCollections();
                }

                this.$emit('resetted');
            },
        },

        created()
        {
            console.log('Listening to the modal event', this.getModalEvent());
            this.$bus.$on(this.getModalEvent(), this.open);
        },

        beforeDestroy()
        {
            this.$bus.$on(this.getModalEvent(), this.open);
        }
    }
</script>